import Add from '@mui/icons-material/Add'
import FileDownload from '@mui/icons-material/GetApp'
import SendEmail from '@mui/icons-material/Send'
import CancelIcon from '@mui/icons-material/Cancel';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { IconButton } from '@mui/material'
import { IInvoice } from 'models/invoices.models'
import {
    getInvoiceFormattedCurrency,
    getInvoiceFormattedDate,
} from 'lib/utils/Invoices/invoices.utils'
import {
    ICFDIsContainerProps,
    useCFDIsContainerContext,
} from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Button from 'components/Shared/Button/Button'
import Table from 'components/Shared/DynamicTable/DynamicTable'
import SydDialog from 'components/Shared/SydDialog/SydDialog'
import './styles.scss'
import HelpOutline from '@mui/icons-material/HelpOutline'
import useDialog from "../../../../hooks/Shared/useDialog";
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
// TODO: UPDATE HEADERS AND TABLE WITH SydTable, CreditNoteTableActions & PaymentComplementTableActions COMPONENTS.

type TCFDIRelatedDocsProps = Pick<ICFDIsContainerProps, 'onRedirect'>

const CFDIRelatedDocs = ({ onRedirect }: TCFDIRelatedDocsProps) => {
    const {
        activeInvoice,
        creditNoteListQuery,
        downloadCreditNoteQuery,
        downloadPayComplementQuery,
        payComplementListQuery,
        relatedDocsDialogOpen,
        selectedAddonVersion,
        sendCreditNoteByEmailMutation,
        sendPayComplementByEmailMutation,
        updateState,
    } = useCFDIsContainerContext()

    const typedInvoice = activeInvoice as IInvoice

    const necessaryId = typedInvoice?.idCfdi

    const dialog = useDialog()

    const formatActionsCreditNote = (id: number, row: any, key: any) => (
        <>
            <IconButton
                id={`downloadCreditNoteBtn_${key}`}
                title="Descargar"
                size="small"
                color="primary"
                onClick={e => {
                    e.stopPropagation()
                    updateState(draft => {
                        draft.selectedCreditNote = row
                    })
                    downloadCreditNoteQuery.refetch()
                }}>
                <FileDownload fontSize="inherit" />
            </IconButton>
            <IconButton
                id={`sendCreditNoteBtn_${key}`}
                title="Enviar por email"
                size="small"
                color="primary"
                onClick={e => {
                    e.stopPropagation()
                    typedInvoice &&
                    sendCreditNoteByEmailMutation.mutate({
                        creditNote: row,
                        invoice: typedInvoice,
                    })
                }}>
                <SendEmail fontSize="inherit" />
            </IconButton>
        </>
    )

    const formatActionsPayComplement = (id: number, row: any, key: any) => {
        const isCancelling = row.status !== 1 &&  row.status !== 2;

        if (row.status === 2) {
            return (
                <span style={{ fontSize: '0.875rem', color: '#f44336', fontWeight: 500 }}>
                 Cancelado
                </span>
            )
        }

        return (
            <>
                <IconButton
                    id={`downloadPayComplementBtn_${key}`}
                    title="Descargar"
                    size="small"
                    color="primary"
                    disabled={isCancelling}
                    onClick={e => {
                        e.stopPropagation()
                        if (!isCancelling) {
                            updateState(draft => {
                                draft.selectedPayComplement = row
                            })
                            downloadPayComplementQuery.refetch()
                        }
                    }}>
                    <FileDownload fontSize="inherit" />
                </IconButton>

                <IconButton
                    id={`sendPayComplementBtn_${key}`}
                    title="Enviar por email"
                    size="small"
                    color="primary"
                    disabled={isCancelling}
                    onClick={e => {
                        e.stopPropagation()
                        if (!isCancelling && typedInvoice) {
                            sendPayComplementByEmailMutation.mutate({
                                payComplement: row,
                                invoice: typedInvoice,
                            })
                        }
                    }}>
                    <SendEmail fontSize="inherit" />
                </IconButton>
                <IconButton
                    id={`cancelPayComplementBtn_${key}`}
                    title={isCancelling ? 'Cancelación en proceso' : 'Cancelar Complemento de pago'}
                    size="small"
                    color="primary"
                    onClick={async e => {
                        e.stopPropagation()

                        if (isCancelling) {
                            return
                        }

                        if (typedInvoice?.imported) return

                        const resp = await dialog.dangerAsync({
                            title: '¿Estás seguro?',
                            subtitle: 'Estás a punto de cancelar uno de tus complementos de pago',
                            icon: HelpOutline as TModalIcon,
                            primaryButtonText: 'Sí, cancelar',
                            secondaryButtonText: 'No, cerrar',
                        })

                        if (!resp) return

                        updateState(draft => {
                            draft.seeMoreAnchor = null
                            draft.cancelCFDIDialogOpen = true
                            draft.selectedPayComplement = row
                            draft.selectedCfdiToCancel = {
                                uuid: row.uuid,
                                type: 'payComplement',
                            }
                        })
                    }}
                >
                    {isCancelling ? <HorizontalRuleIcon fontSize="inherit" /> : <CancelIcon fontSize="inherit" />}
                </IconButton>


            </>
        )
    }

    const creditNoteHeaders = [
        {
            label: 'Fecha de Pago',
            accesor: 'createdAt',
            renderer: getInvoiceFormattedDate,
        },
        { label: 'UUID', accesor: 'uuid' },
        { label: 'Total', accesor: 'total', renderer: getInvoiceFormattedCurrency },
        {
            label: '',
            accesor: 'idCfdi',
            renderer: formatActionsCreditNote,
            cellClassName: 'options',
        },
    ]

    const paymentComplementHeaders = [
        {
            label: 'Fecha de Pago',
            accesor: 'paymentDate',
            renderer: getInvoiceFormattedDate,
        },
        { label: 'UUID', accesor: 'uuid' },
        {
            label: 'Total',
            accesor: 'amount',
            renderer: getInvoiceFormattedCurrency,
        },
        {
            label: '',
            accesor: '',
            renderer: (value: any, row: any, key: any) => formatActionsPayComplement(row.idCfdi, row, key),
            cellClassName: 'options',
        },
    ]

    return (
        <SydDialog
            open={relatedDocsDialogOpen}
            className="dialog-invoices cfdi-related-docs"
            onCancel={() =>
                updateState(draft => {
                    draft.relatedDocsDialogOpen = false
                })
            }
            hidePrimaryButton
            secondaryButtonText="Cerrar"
            sideButtons
            fullWidth>
            <h1>Lista de Complementos de Pago</h1>
            <Button
                id="addPaymentComplementBtn"
                variant="contained"
                color="secondary"
                startIcon={<Add />}
                onClick={() =>
                    !!necessaryId &&
                    onRedirect('addPaymentComplement', necessaryId, selectedAddonVersion)
                }>
                Agregar complemento de pago
            </Button>
            <Table
                headers={paymentComplementHeaders}
                rows={payComplementListQuery.data ?? []}
                loading={payComplementListQuery.isLoading}
                fetching={payComplementListQuery.isFetching}
            />

            <h1>Lista de Notas de credito</h1>
            <Button
                id="addCreditNoteBtn"
                variant="contained"
                color="secondary"
                startIcon={<Add />}
                onClick={() =>
                    !!necessaryId &&
                    onRedirect('addCreditNote', necessaryId, selectedAddonVersion)
                }>
                Agregar nota de credito
            </Button>

            <Table
                headers={creditNoteHeaders}
                rows={creditNoteListQuery.data ?? []}
                loading={creditNoteListQuery.isLoading}
                fetching={creditNoteListQuery.isFetching}
            />
        </SydDialog>
    )
}

export default CFDIRelatedDocs
